// noinspection JSUnusedGlobalSymbols

import {defaultDataIdFromObject, InMemoryCache, TypePolicy} from "@apollo/client/core";

const mergeProps = (existing: any, incoming: any) => {
    return ({...existing, ...incoming})
}
const noCache = {
    keyFields: false, // Prevents caching entirely for this type
    fields: {
        fieldName: {
            read(existing) {
                return existing; // Avoid complex field cache resolution
            },
            merge(existing, incoming) {
                return incoming; // Replace existing value with new value
            }
        }
    }
} as TypePolicy;
export const cache = new InMemoryCache({
    dataIdFromObject(responseObject) {
        if (responseObject.hasOwnProperty('id')) return `${responseObject.__typename}:${responseObject.id}`;
        if (responseObject.hasOwnProperty('code')) return `${responseObject.__typename}:${responseObject.code}`;
        if (responseObject.hasOwnProperty('customerId')) return `${responseObject.__typename}:${responseObject.customerId}`;
        return defaultDataIdFromObject(responseObject);
    },
    possibleTypes: {
        DeliveryMethod: ["DefaultDeliveryMethod", "PickupDeliveryMethod", "BpostDelivery"],
        ProductVariant: ["DefaultProductVariant", "UnavailableProductVariant"],
    },
    typePolicies: {
        Tenant: {
            keyFields: [],
        },
        CustomerAccount: {
            keyFields: ["username"],
            fields: {
                orderLists: {
                    keyArgs: ["paging"],
                    merge: mergeProps
                }
            }
        },
        Customer: {
            fields: {
                orders: {
                    keyArgs: ["paging"],
                    merge: mergeProps
                },
            }
        },
        Order: {
            fields: {
                date: {merge: mergeProps},
                cost: {merge: mergeProps},
                state: {merge: mergeProps},
            },
        },
        Code: {
            keyFields: ["value"],
        },
        Address: noCache,
        ValidationMessageArgument: noCache,
        LineItemError: noCache,
        VariantLineItemImpl: noCache,
        PromoLineItem: noCache
    },
});
export default cache